module.exports = __webpack_public_path__ + "assets/img/block-left-a02a69a1.png";